import { Table, TableProps } from "@mui/material";
import { LoadingBox } from "../LoadingBox";

type MainTableProps = {
  loading?: boolean;
} & TableProps;

export const MainTable = ({ sx, loading, ...others }: MainTableProps) => {
  return (
    <LoadingBox loading={loading} loadingPosition="start">
      <Table
        sx={[
          {
            width: "100%",
            borderCollapse: "collapse",
            "& td, & th": {
              borderBottom: "none",
              "&:last-child": {
                textAlign: "right",
                paddingRight: "0",
              },
              "&:first-of-type": {
                textAlign: "left",
                paddingLeft: "0",
              },
            },
            "& th": {
              color: "text.secondary",
              textTransform: "uppercase",
              fontSize: "0.625rem",
              fontWeight: "500",
              lineHeight: "0.75rem",
              paddingTop: "0",
              paddingBottom: "0",
              border: "none",
            },
            "& tbody td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium": {
              fontSize: "1rem !important",
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...others}
      ></Table>
    </LoadingBox>
  );
};

export default MainTable;
